export default __webpack_public_path__ + "static/footer-cheers-49856586acf63778a6f68326e03f7bc6.png";